"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
exports.default = (0, DefaultPropsHoC_1.default)(Stack_1.default, {
    direction: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    py: 1,
});
